var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('div', [_c('h3', {
    staticClass: "mt-4 heading"
  }, [_vm._v("Diagnostic Center Name")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "pin-map",
      "scale": "1.5"
    }
  })], 1), _c('b-col', [_c('span', [_vm._v("6, Blue Mount Compound, St. Michael Church Road, Mumbai, Maharastra")])])], 1)], 1), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "phone",
      "scale": "1.5"
    }
  })], 1), _c('b-col', [_c('span', [_vm._v("+91 987654321")])])], 1)], 1), _c('div', [_c('h3', {
    staticClass: "mt-4 heading"
  }, [_vm._v("About Center")]), _c('p', [_vm._v(" Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iste reiciendis quasi minima, et dolorum nostrum explicabo nam perferendis voluptates labore aliquam accusantium pariatur sit incidunt quas sequi est nihil doloremque! ")])]), _c('div', [_c('h3', {
    staticClass: "mt-4 heading"
  }, [_vm._v("Available Tests")]), _c('ul', [_c('li', [_vm._v("test1")]), _c('li', [_vm._v("test2")]), _c('li', [_vm._v("test3")]), _c('li', [_vm._v("test4")])])])]), _c('b-col', {
    attrs: {
      "offset": "2",
      "md": "5"
    }
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "image-icons"
  }, [_c('div', [_c('b-icon', {
    staticClass: "action-icon",
    attrs: {
      "icon": "heart"
    }
  })], 1), _c('div', [_c('b-icon', {
    staticClass: "action-icon",
    attrs: {
      "icon": "share"
    }
  })], 1)]), _c('b-carousel', {
    staticStyle: {
      "text-shadow": "0px 0px 2px #000"
    },
    attrs: {
      "id": "carousel-fade",
      "fade": "",
      "indicators": "",
      "img-width": "1024",
      "img-height": "480"
    }
  }, [_c('b-carousel-slide', {
    attrs: {
      "caption": "",
      "img-src": "https://picsum.photos/1024/480/?image=10"
    }
  }), _c('b-carousel-slide', {
    attrs: {
      "caption": "",
      "img-src": "https://picsum.photos/1024/480/?image=12"
    }
  }), _c('b-carousel-slide', {
    attrs: {
      "caption": "",
      "img-src": "https://picsum.photos/1024/480/?image=22"
    }
  })], 1)], 1), _c('div', [_c('h3', {
    staticClass: "mt-3 heading"
  }, [_vm._v("Rate & Reviews")]), _c('div', [[_c('div', [_c('b-form-rating', {
    staticClass: "review-star",
    attrs: {
      "readonly": "",
      "variant": "warning",
      "inline": "",
      "no-border": ""
    },
    model: {
      value: _vm.starValue,
      callback: function ($$v) {
        _vm.starValue = $$v;
      },
      expression: "starValue"
    }
  })], 1)], _c('div', [_c('p', {
    staticClass: "review-title"
  }, [_vm._v("Good Service")]), _c('p', [_vm._v(" Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti, asperiores. ")]), _c('p', {
    staticClass: "reviewer"
  }, [_vm._v("John George")])]), _c('hr')], 2)])])], 1), _c('b-row', [_c('b-col', [_c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.itemSuggestions,
      "subTitle": "Related Packages",
      "showTitle": true,
      "hasBackground": false,
      "hasButton": true,
      "withSlider": true,
      "viewMorePage": {
        name: `health-care-listing`,
        params: {
          items: `Most Popular`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box ml-2 mr- 2"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }])
  })], 1)], 1), _c('b-row', [_c('b-col', [_c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.diagnosticBanner.icon && _vm.diagnosticBanner.icon.fileUrl || '',
      "alt": "Diagnostic Centers Bottom Banner"
    }
  })])])], 1), _c('b-row', [_c('b-col', [_c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.itemSuggestions,
      "subTitle": "Recently Searched",
      "showTitle": true,
      "hasBackground": false,
      "hasButton": true,
      "withSlider": true,
      "viewMorePage": {
        name: `health-care-listing`,
        params: {
          items: `Most Popular`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var listItem = _ref2.listItem;
        return [_c('div', {
          staticClass: "item-box ml-2 mr- 2"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }